import NextLevelView from "./NextLevelView"

export default NextLevelView;